import type { FC } from "react";

import type { ContentType } from "../../src/types/contents/contents";
import type { Diet } from "../../src/types/contents/diet";
import type { Exercise } from "../../src/types/contents/exercise";
import type { Metric } from "../../src/types/contents/metric/metric";
import type { Program } from "../../src/types/contents/program";
import type { Sport } from "../../src/types/contents/sport";
import type { Tip } from "../../src/types/contents/tip";
import type { Workout } from "../../src/types/contents/workout";

import { ContentList } from "./components/ContentList";
import { ExerciseComponent } from "./components/Exercise";
import { Login } from "./components/Login";
import { ProgramComponent } from "./components/Program";
import { TipComponent } from "./components/Tip";
import { UserPage } from "./components/User";
import { WorkoutComponent } from "./components/Workout";

type Route = {
  path: string;
  name: string;
  Component: FC<never>;
  props?: {
    contentType?: ContentType;
  };
  routeRegex?: RegExp;
  hideFromNavigation?: boolean;
};

const exerciseRoutes: Route[] = [
  {
    path: "/exercises",
    name: "Exercises",
    Component: ContentList<Exercise>,
    props: { contentType: "exercise" },
  },
  {
    path: "/exercise/new",
    name: "New exercise",
    Component: ExerciseComponent,
    hideFromNavigation: true,
  },
  {
    path: "/exercise/:id",
    name: "Exercise",
    Component: ExerciseComponent,
    routeRegex: /\/exercise\/\d+/,
    hideFromNavigation: true,
  },
];

const tipRoutes: Route[] = [
  {
    path: "/tips",
    name: "Tips",
    Component: ContentList<Tip>,
    props: { contentType: "tip" },
  },
  {
    path: "/tip/new",
    name: "New tip",
    Component: TipComponent,
    hideFromNavigation: true,
  },
  {
    path: "/tip/:id",
    name: "Tip",
    Component: TipComponent,
    routeRegex: /\/tip\/\d+/,
    hideFromNavigation: true,
  },
];

const workoutRoutes: Route[] = [
  {
    path: "/workouts",
    name: "Workouts",
    Component: ContentList<Workout>,
    props: { contentType: "workout" },
  },
  {
    path: "/workout/new",
    name: "New workout",
    Component: WorkoutComponent,
    hideFromNavigation: true,
  },
  {
    path: "/workout/:id",
    name: "Workout",
    Component: WorkoutComponent,
    routeRegex: /\/workout\/\d+/,
    hideFromNavigation: true,
  },
];

const programRoutes: Route[] = [
  {
    path: "/programs",
    name: "Programs",
    Component: ContentList<Program>,
    props: { contentType: "program" },
  },
  {
    path: "/program/new",
    name: "New program",
    Component: ProgramComponent,
    hideFromNavigation: true,
  },
  {
    path: "/program/:id",
    name: "Program",
    Component: ProgramComponent,
    routeRegex: /\/program\/\d+/,
    hideFromNavigation: true,
  },
];

export const routes: Route[] = [
  {
    path: "/",
    name: "Profile",
    Component: UserPage,
  },
  {
    path: "/login",
    name: "Login",
    Component: Login,
  },
  ...exerciseRoutes,
  ...tipRoutes,
  ...workoutRoutes,
  ...programRoutes,
  {
    path: "/metric",
    name: "Metrics",
    Component: ContentList<Metric>,
    props: { contentType: "metric" },
  },
  {
    path: "/sports",
    name: "Sports",
    Component: ContentList<Sport>,
    props: { contentType: "sport" },
  },
  {
    path: "/diets",
    name: "Diets",
    Component: ContentList<Diet>,
    props: { contentType: "diet" },
  },
];
